import { render } from "./kitchenSpace.vue?vue&type=template&id=7d57247f&scoped=true"
import script from "./kitchenSpace.vue?vue&type=script&lang=js"
export * from "./kitchenSpace.vue?vue&type=script&lang=js"

import "./kitchenSpace.vue?vue&type=style&index=0&id=7d57247f&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d57247f"]])

export default __exports__